module.exports = __webpack_public_path__ + "static/media/google2.ddaa6531.jpg";